// extracted by mini-css-extract-plugin
export default {"landing_text":"NameHeader_landing_text__xC+YJ"};